export default "__VITE_ASSET__DE_1xWD9__"